module.exports = __webpack_public_path__ + "media/images/desktop-sea-world-c2b332c47817b232420b782f01a11bd1.jpg";